export const suppressApolloDeprecationWarnings = () => {
  // Temporarily mute Apollo 3 deprecations until query callbacks are migrated for Apollo 4.
  Object.assign(globalThis, { [Symbol.for('apollo.deprecations')]: true });
};
